import React from "react";
import Home from "../components/home";
import { ProtectedRoute } from "../components/Auth";

const HomePage = () => {
    return (
        <ProtectedRoute>
            <Home />
        </ProtectedRoute>
    );
};

export default HomePage;
